import { CoreTooltip } from '@featuring-corp/components';
import { IconInformationFilled } from '@featuring-corp/icons';
import { vars } from '@styles/vanilla-extract/theme.css';
import { flex } from '@styles/vanilla-extract/utils';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import {
	cardClass,
	cardHeight,
	contentClass,
	labelClass,
	lackOfPermissionClass,
} from './style.css';

export interface ReportCardProps extends ComponentPropsWithoutRef<'div'> {
	label?: string;
	tooltip?: string;
	children?: ReactNode | ReactNode[];
	lackOfPermission?: boolean;
	height?: number | string;
	align?: 'vertical' | 'horizontal';
}

const ReportCard = ({
	label,
	tooltip,
	children,
	lackOfPermission,
	height = 310,
	align = 'vertical',
	className,
	...props
}: ReportCardProps) => {
	const convertSizeToString = (size: number | string) => {
		if (typeof size === 'number') {
			return `${size}px`;
		}

		return size;
	};

	return (
		<div
			className={clsx(cardClass({ align }), className)}
			style={assignInlineVars({ [cardHeight]: convertSizeToString(height) })}
			{...props}
		>
			<div className={flex({ gap: 'spacing-100' })}>
				<div className={labelClass}>{label}</div>
				{tooltip && (
					<CoreTooltip text={tooltip} autoAdjust zIndex={10000}>
						<IconInformationFilled fill={vars.semantic.color.icon.tertiary} />
					</CoreTooltip>
				)}
			</div>

			<div className={lackOfPermission ? lackOfPermissionClass : contentClass}>
				{children}
			</div>
		</div>
	);
};

export default ReportCard;
